import { Injectable, inject } from '@angular/core';

import { Actions, createEffect } from '@ngrx/effects';

import { AuthService } from '@views/misc/auth/auth.service';

import * as actions from './user.actions';
import { UserService } from './user.service';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);
  private userService = inject(UserService);

  resendConfirmationEmail$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: () => this.userService.resendConfirmEmail(),
      successMessage: 'Validation email has been resent.',
      errorMessage: 'Sorry, there has been an error sending your validation email.',
      startAction: actions.userResendConfirmationEmailStart,
      successAction: actions.userResendConfirmationEmailSuccess,
      failAction: actions.userResendConfirmationEmailFail,
    }),
  );
}
